module.exports = __webpack_public_path__ + "img/avi.ac51ab8.svg";